import data from "../configs/data";
import {EuropeanRoulette} from "../EuropeanRoulette";
import {ChipsStack} from "./ChipsStack";
import {IChipsStacks} from "./IChipsStacks";

export class SmallBetsChipsStacks extends PIXI.Container implements IChipsStacks {

    private straightBetsChipsStacks: Array<ChipsStack> = [];
    private splitBetsChipsStacks: Array<ChipsStack> = [];
    private cornerBetsChipsStacks: Array<ChipsStack> = [];
    private lineBetsChipsStacks: Array<ChipsStack> = [];
    private streetBetsChipsStacks: Array<ChipsStack> = [];
    private columnBetsChipsStacks: Array<ChipsStack> = [];
    private dozenBetsChipsStacks: Array<ChipsStack> = [];
    private lowHighNumbersBetsChipsStacks: Array<ChipsStack> = [];
    private evenOddBetsChipsStacks: Array<ChipsStack> = [];
    private colorBetsChipsStacks: Array<ChipsStack> = [];

    private readonly TOKEN_VALUES = [1, 0.5, 0.25, 0.1, 0.05, 0.01];
    private readonly TOKEN_CHIPS_STACKS_PATHS = [
        data.images.smallBetsCasinoChipValue1,
        data.images.smallBetsCasinoChipValue05,
        data.images.smallBetsCasinoChipValue025,
        data.images.smallBetsCasinoChipValue01,
        data.images.smallBetsCasinoChipValue005,
        data.images.smallBetsCasinoChipValue001,
    ];

    constructor(straightBetsOffsetX: number, straightBetsOffsetY: number,
                offsetFromZero: number, dozenBetsPositionY: number, evenOddColorLowHighBetsPositionY: number,
                lowNumbersBetPositionX: number, evenBetPositionX: number, redColorBetPositionX: number,
                blackColorBetPositionX: number, oddBetPositionX: number, highNumbersBetPositionX: number) {
        super();
        this.createAndAddZeroStraightBetChipsStacks(straightBetsOffsetY);
        this.createAndAddStraightBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddSplitBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddCornerBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddLineBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddStreetBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddColumnBetsChipsStacks(straightBetsOffsetX, straightBetsOffsetY, offsetFromZero);
        this.createAndAddDozenBetsChipsStacks(straightBetsOffsetX, offsetFromZero, dozenBetsPositionY);
        this.createAndAddLowHighNumbersBetsChipsStacks(lowNumbersBetPositionX, highNumbersBetPositionX,
            evenOddColorLowHighBetsPositionY);
        this.createAndAddEvenOddBetsChipsStacks(evenBetPositionX, oddBetPositionX,
            evenOddColorLowHighBetsPositionY);
        this.createAndColorBetsChipsStacks(redColorBetPositionX, blackColorBetPositionX,
            evenOddColorLowHighBetsPositionY);
    }

    public setStraightBetChipsStack(selectedNumber: number, stackValue: number): void {
        this.straightBetsChipsStacks[selectedNumber].setStack(stackValue);
    }

    public setSplitBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.splitBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setCornerBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.cornerBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setLineBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.lineBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setStreetBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.streetBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setColumnBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.columnBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setDozenBetChipsStack(selectedIndex: number, stackValue: number): void {
        this.dozenBetsChipsStacks[selectedIndex].setStack(stackValue);
    }

    public setLowHighNumbersBetChipsStack(lowNumbers: boolean, stackValue: number): void {
        if (lowNumbers) {
            this.lowHighNumbersBetsChipsStacks[0].setStack(stackValue);
        } else {
            this.lowHighNumbersBetsChipsStacks[1].setStack(stackValue);
        }
    }

    public setEvenOddBetChipsStack(evenNumbers: boolean, stackValue: number): void {
        if (evenNumbers) {
            this.evenOddBetsChipsStacks[0].setStack(stackValue);
        } else {
            this.evenOddBetsChipsStacks[1].setStack(stackValue);
        }
    }

    public setColorBetsChipsStacks(redColor: boolean, stackValue: number): void {
        if (redColor) {
            this.colorBetsChipsStacks[0].setStack(stackValue);
        } else {
            this.colorBetsChipsStacks[1].setStack(stackValue);
        }
    }

    public removeAllStacks(): void {
        for (let i = 0; i < this.straightBetsChipsStacks.length; i++) {
            this.straightBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.splitBetsChipsStacks.length; i++) {
            this.splitBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.cornerBetsChipsStacks.length; i++) {
            this.cornerBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.lineBetsChipsStacks.length; i++) {
            this.lineBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.streetBetsChipsStacks.length; i++) {
            this.streetBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.columnBetsChipsStacks.length; i++) {
            this.columnBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.dozenBetsChipsStacks.length; i++) {
            this.dozenBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.lowHighNumbersBetsChipsStacks.length; i++) {
            this.lowHighNumbersBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.evenOddBetsChipsStacks.length; i++) {
            this.evenOddBetsChipsStacks[i].setStack(0);
        }
        for (let i = 0; i < this.colorBetsChipsStacks.length; i++) {
            this.colorBetsChipsStacks[i].setStack(0);
        }
    }

    private createAndAddStraightBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                                offsetFromZero: number): void {
        let columnCurrentIndex = 0;
        for (let numberValue = 1; numberValue <= EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER; numberValue++) {
            const row = 2 - ((numberValue - 1) % 3);
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = offsetFromZero + columnCurrentIndex * straightBetsOffsetX;
            chipsStack.position.y = row * straightBetsOffsetY;
            this.straightBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private createAndAddZeroStraightBetChipsStacks(straightBetsOffsetY: number): void {
        const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

        chipsStack.position.y = straightBetsOffsetY;
        this.straightBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);
    }

    private createAndAddSplitBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                             straightBetsOffsetFromZero: number): void {

        let columnCurrentIndex = 0;
        for (let index = 0; index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER; index++) {
            const row = 2 - (index % 3);
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero - straightBetsOffsetX / 2 +
                columnCurrentIndex * straightBetsOffsetX;
            chipsStack.position.y = row * straightBetsOffsetY;
            this.splitBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }

        columnCurrentIndex = 0;

        for (let index = EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER * 5 / 3; index++) {
            const row = 1 - (index % 2);
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero + columnCurrentIndex * straightBetsOffsetX;
            chipsStack.position.y = row * straightBetsOffsetY + straightBetsOffsetY / 2;
            this.splitBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private createAndAddCornerBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                              straightBetsOffsetFromZero: number): void {
        let columnCurrentIndex = 0;
        for (let index = 0;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER * 2 / 3; index++) {
            const row = 1 - (index % 2);
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
            chipsStack.position.x = straightBetsOffsetFromZero - straightBetsOffsetX / 2 +
                columnCurrentIndex * straightBetsOffsetX;
            chipsStack.position.y = row * straightBetsOffsetY + straightBetsOffsetY / 2;
            this.cornerBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private createAndAddLineBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                            straightBetsOffsetFromZero: number): void {
        for (let index = 0;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER / 3; index++) {
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero - straightBetsOffsetX / 2 +
                index * straightBetsOffsetX;
            chipsStack.position.y = straightBetsOffsetY * 2 + straightBetsOffsetY / 2;
            this.lineBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
        }
    }

    private createAndAddStreetBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                              straightBetsOffsetFromZero: number): void {
        for (let index = 0;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER / 3; index++) {
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero + index * straightBetsOffsetX;
            chipsStack.position.y = straightBetsOffsetY * 2 + straightBetsOffsetY / 2;
            this.streetBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
        }
    }

    private createAndAddColumnBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetY: number,
                                              straightBetsOffsetFromZero: number): void {
        for (let index = 0;
             index < 3; index++) {
            const row = 2 - (index % 3);
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero + straightBetsOffsetX * 12;
            chipsStack.position.y = row * straightBetsOffsetY;
            this.columnBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
        }
    }

    private createAndAddDozenBetsChipsStacks(straightBetsOffsetX: number, straightBetsOffsetFromZero: number,
                                             positionY: number): void {
        for (let index = 0; index < 3; index++) {
            const chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);

            chipsStack.position.x = straightBetsOffsetFromZero + straightBetsOffsetX * (3 / 2 + 4 * index);
            chipsStack.position.y = positionY;
            this.dozenBetsChipsStacks.push(chipsStack);
            this.addChild(chipsStack);
        }
    }

    private createAndAddLowHighNumbersBetsChipsStacks(lowNumbersPositionX: number, highNumbersPositionX: number,
                                                      positionY: number): void {
        let chipsStack;
        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = lowNumbersPositionX;
        chipsStack.position.y = positionY;
        this.lowHighNumbersBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);

        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = highNumbersPositionX;
        chipsStack.position.y = positionY;
        this.lowHighNumbersBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);
    }

    private createAndAddEvenOddBetsChipsStacks(evenNumbersPositionX: number, oddNumbersPositionX: number,
                                               positionY: number): void {
        let chipsStack;
        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = evenNumbersPositionX;
        chipsStack.position.y = positionY;
        this.evenOddBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);

        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = oddNumbersPositionX;
        chipsStack.position.y = positionY;
        this.evenOddBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);
    }

    private createAndColorBetsChipsStacks(redColorPositionX: number, blackColorPositionX: number,
                                          positionY: number): void {
        let chipsStack;
        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = redColorPositionX;
        chipsStack.position.y = positionY;
        this.colorBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);

        chipsStack = new ChipsStack(this.TOKEN_CHIPS_STACKS_PATHS, this.TOKEN_VALUES);
        chipsStack.position.x = blackColorPositionX;
        chipsStack.position.y = positionY;
        this.colorBetsChipsStacks.push(chipsStack);
        this.addChild(chipsStack);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/SmallBetsChipsStacks.ts